import { jsx as _jsx } from "react/jsx-runtime";
import { getServerSyncedTime } from '../../../utils/TimeUtils';
import { useFullTrack, useTrackPendingPracticalExercises } from '../../tracks';
import ExamIncompleteExercisesScreen from './ExamIncompleteExercisesScreen';
import ExamCongratulationsScreen from './ExamCongratulationsScreen';
import ExamCertificationExpiredScreen from './ExamCertificationExpiredScreen';
import ExamAttemptExpiredScreen from './ExamAttemptExpiredScreen';
import ExamAttemptExpiredIncompleteExercisesScreen from './ExamAttemptExpiredIncompleteExercisesScreen';
import ExamAttemptFailedScreen from './ExamAttemptFailedScreen';
import { useTrackAwardProgress } from '../../userProgress';
import { useAttemptExpiry, useExamExpiry, useMostRecentExamAttempt } from '../../exams';

const ExamFinishedScreen = ({
  trackId
}) => {
  const {
    pendingPracticalExercises
  } = useTrackPendingPracticalExercises(trackId.toString());
  const {
    track
  } = useFullTrack(trackId);
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    isExpired
  } = useExamExpiry(Number(trackId));
  const {
    isAttemptExpired
  } = useAttemptExpiry(Number(trackId));
  const {
    award
  } = useTrackAwardProgress(Number(trackId));
  const examIsRecent = mostRecentExamAttempt ? getServerSyncedTime() - mostRecentExamAttempt.attemptFinishTime < 24 * 60 * 60 * 1000 : false;
  const probablyHasCert = track && track.certification && mostRecentExamAttempt && mostRecentExamAttempt.passed && pendingPracticalExercises && !pendingPracticalExercises.length;
  const attemptFinished = mostRecentExamAttempt && mostRecentExamAttempt.finished;
  const attemptFinishedNotExpired = attemptFinished && !isExpired;
  const certificationExpired = !examIsRecent && isExpired;
  const practicalExercisesFinished = pendingPracticalExercises && !pendingPracticalExercises.length;
  const awardNotYetLoaded = !award && probablyHasCert && examIsRecent;
  const passed = mostRecentExamAttempt && mostRecentExamAttempt.passed;

  if (passed && attemptFinishedNotExpired && !isAttemptExpired && !practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamIncompleteExercisesScreen, {
      trackId: trackId
    });
  }

  if (passed && practicalExercisesFinished && !certificationExpired && !isAttemptExpired && (awardNotYetLoaded || award)) {
    return /*#__PURE__*/_jsx(ExamCongratulationsScreen, {
      trackId: trackId
    });
  }

  if (passed && certificationExpired && practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamCertificationExpiredScreen, {
      trackId: trackId
    });
  }

  if (passed && isAttemptExpired && practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamAttemptExpiredScreen, {
      trackId: trackId
    });
  }

  if (passed && isAttemptExpired && !practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamAttemptExpiredIncompleteExercisesScreen, {
      trackId: trackId
    });
  }

  return /*#__PURE__*/_jsx(ExamAttemptFailedScreen, {
    trackId: trackId
  });
};

export default ExamFinishedScreen;